import { Outlet, Route, Routes } from 'react-router'
import { Authenticated } from '@refinedev/core'
import { CatchAllNavigate } from '@refinedev/react-router'
import { RequestShow, RequestsList } from '@screens/requests'
import { Login } from '@screens/login'
import { Register } from '@screens/register'
import { ForgotPassword } from '@screens/forgot-password'
import { ResetPassword } from '@screens/reset-password'
import { ShareLogin } from '@screens/share-login'
import { Layout } from '@app/components/Layout'
import { SharePage, ShareShow } from '@screens/share'
import { ROLES } from '@modules/types'
import {
  RootRedirectHandler,
  ProtectedRouteHandler,
  LoadingScreen,
  ShareRedirectHandler,
} from '@publisher/modules/routing'
import { ShareAnalyticsProvider } from '@publisher/modules/analytics'
import { NotFound } from '@screens/not-found'

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/shared/:id" element={<ShareRedirectHandler />} />

      <Route
        element={
          <Authenticated
            key="authenticated-layout"
            fallback={<CatchAllNavigate to="/login" />}
            loading={<LoadingScreen />}
          >
            <Outlet />
          </Authenticated>
        }
      >
        <Route
          path="/share"
          element={
            <ProtectedRouteHandler
              allowedRoles={[ROLES.ADMIN_PANEL_SHARED_REQUEST_USER]}
              fallbackRedirect="/request"
            >
              <ShareAnalyticsProvider>
                <Layout>
                  <SharePage />
                </Layout>
              </ShareAnalyticsProvider>
            </ProtectedRouteHandler>
          }
        />

        <Route
          path="/share/:id"
          element={
            <ProtectedRouteHandler
              allowedRoles={[ROLES.ADMIN_PANEL_SHARED_REQUEST_USER]}
              fallbackRedirect="/share-login"
            >
              <ShareAnalyticsProvider>
                <Layout>
                  <ShareShow />
                </Layout>
              </ShareAnalyticsProvider>
            </ProtectedRouteHandler>
          }
        />

        <Route
          path="/"
          element={
            <ProtectedRouteHandler
              allowedRoles={[
                ROLES.ADMIN_PANEL_PUBLISHER,
                ROLES.ADMIN_PANEL_COPYRIGHT_MANAGER,
                ROLES.ADMIN_PANEL_SHARED_REQUEST_USER,
              ]}
              fallbackRedirect="/login"
            >
              <RootRedirectHandler />
            </ProtectedRouteHandler>
          }
        />
        <Route
          path="/request"
          element={
            <ProtectedRouteHandler
              allowedRoles={[ROLES.ADMIN_PANEL_PUBLISHER, ROLES.ADMIN_PANEL_COPYRIGHT_MANAGER]}
              fallbackRedirect="/share"
            >
              <Layout>
                <RequestsList>
                  <Outlet />
                </RequestsList>
              </Layout>
            </ProtectedRouteHandler>
          }
        >
          <Route path="/request/:id" element={<RequestShow />} />
        </Route>
      </Route>

      {/* Auth pages */}
      <Route path="/login" element={<Login />} />
      <Route path="/share-login" element={<ShareLogin />} />
      <Route path="/activate" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      {/* 404 route - only for authenticated users */}
      <Route
        path="*"
        element={
          <Authenticated key="404-route" fallback={<CatchAllNavigate to="/login" />}>
            <NotFound />
          </Authenticated>
        }
      />
    </Routes>
  )
}
